<template>
  <v-app>
    <component v-bind:is="layout"></component>
  </v-app>
</template>

<script>
import Login from './Login'
import Layout from './Layout'
export default {
  computed: {
    layout () {
      return this.$store.state.layout
    }
  },
  components: {
    'layout': Layout,
    'login': Login
    // define as many layouts you want for the application
  }
}
</script>